module.exports = __webpack_public_path__ + "static/media/Lake-Village-II-Pet-policy.02aa6806.pdf";